/* angular:styles/component:css;a1b1336afb63cbe81b5f21a850f88ebfc993b6fd82ec0cf3307a779c4bdd994d;/Users/pascalpeeters/one2three-web/src/app/profile/profile.component.ts */
.example-pizza-party {
  color: hotpink;
}
/*# sourceMappingURL=profile.component.css.map */
